import "./App.css";
import Header from "./components/Header.component";
import { Footer } from "./components/footer.component";

const App = () => {
  return (
    <div style={{ padding: "50px", paddingTop: "20px" }}>
      <Header />
      <Footer />
    </div>
  );
};

export default App;
